import DetailFormHead from "components/subHead/detailFormHead";
import Cell from "components/rows/cell";
import LodInfRow from "components/rows/lodRow";
import { dateFormat, getDay } from "components/utils/comm";
import i18n from "locales/i18n";
import { useTranslation } from "react-i18next";
import { useGetData } from "./service";
import BaseInfLoaing from "components/detailLoading/baseInf";
import TableRow from "components/rows/tableRow";

export default function HistoryDetail() {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const { rmPdHistDtl, isLoading, isSuccess } = useGetData();

  return (
    <>
      <>
        {/* 기본정보 */}
        <DetailFormHead title={t("row_ttl_default")} />
        {(!rmPdHistDtl || isLoading) && (
          <BaseInfLoaing rowTitle={"row_ttl_rm_inf"} isData={isSuccess} />
        )}
        {rmPdHistDtl && (
          <table>
            <tbody>
              <LodInfRow />

              <TableRow title={t("row_ttl_rm_inf")}>
                <ul>
                  <li>
                    <Cell label={t("lbl_rm_no")} value={rmPdHistDtl?.rmNo} />
                  </li>
                  <li>
                    <Cell label={t("lbl_rm_nm")} value={rmPdHistDtl?.rmNm} />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}

        {/* 상품정보 */}
        <DetailFormHead title={t("sub_ttl_rmpd_inf")} />
        {(!rmPdHistDtl || isLoading) && (
          <BaseInfLoaing rowTitle={"row_ttl_rm_pd"} isData={isSuccess} />
        )}
        {rmPdHistDtl && (
          <table>
            <tbody>
              <TableRow title={t("row_ttl_rm_pd")}>
                <ul>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_no")}
                      value={rmPdHistDtl?.rmPdHistNo}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_op_nm")}
                      value={rmPdHistDtl?.rmOpNm}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_chl")}
                      value={rmPdHistDtl?.lodChlNm}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rmpd_dt")}
                      value={dateFormat(rmPdHistDtl?.sellDt ?? "", "-")}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rm_day")}
                      value={getDay({
                        dayNm: rmPdHistDtl?.dowV,
                        langCd: langCd,
                      })}
                    />
                  </li>
                  <li>
                    <Cell label={t("lbl_rm_ct")} value={rmPdHistDtl?.rmPdCt} />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_sell_ct")}
                      value={rmPdHistDtl?.sellYCt}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_cnl_ct")}
                      // labelFor="bold"
                      value={rmPdHistDtl?.sellNCt}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_rm_sell_yn")}
                      value={
                        rmPdHistDtl?.sellYn === "Y"
                          ? t("status_sell_y")
                          : t("status_sell_n")
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_fst_crt_nm")}
                      value={rmPdHistDtl?.fstCrtAscrNm ?? ""}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_fst_crt_no")}
                      value={rmPdHistDtl?.fstCrtAscrNo}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_edit_nm")}
                      value={rmPdHistDtl?.acsrNm ?? ""}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_edit_no")}
                      value={rmPdHistDtl?.acsrNo}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_hst_st_typ")}
                      value={
                        rmPdHistDtl?.histStaTyp === "C"
                          ? t("txt_create")
                          : rmPdHistDtl?.histStaTyp === "U"
                          ? t("txt_update")
                          : rmPdHistDtl?.histStaTyp === "D"
                          ? t("txt_delete")
                          : ""
                      }
                    />
                  </li>
                  <li className="w-full h-auto">
                    <label htmlFor="">{t("txt_memo")}</label>
                    <textarea name="" id="" defaultValue={rmPdHistDtl?.memo} />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        )}
      </>
    </>
  );
}
